import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Slotss from './components/Slotss';

const slotss = (props,{ t }) => (
  <Container>
    <Slotss {...props} />
  </Container>
);

slotss.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(slotss);
